const utils = {
    install(Vue, options) {
        Vue.prototype.$isCurrentLang = function(lang) {
            const curLang = localStorage.getItem('lang');
            return curLang === lang;
        };
    }
    // isCurrentLang(lang) {
    //     const curLang = localStorage.getItem('lang');
    //     return curLang === lang;
    // }
};
export default utils;